import React, { Children } from 'react';
import Helmet from 'react-helmet';
import { keys } from 'lodash';
import favicon from 'assets/images/favicon.ico';
import { metaPropTypes } from 'config/propTypes';

import logo from 'assets/images/logos/selfstorage-social-logo.png';

export default function Head({
	description = 'With over 40,000 storage facilities, SelfStorage.com helps you rent the cheapest self-storage units. Check local prices, amenities & book online.',
	title = 'SelfStorage.com: Find Cheap Storage Units Near You',
	canonical,
	meta,
	links = [],
	noIndex,
	noFollow,
}) {
	return (
		<Helmet>
			{!noIndex && !!canonical && (
				<link
					rel="canonical"
					href={canonical}
				/>
			)}
			<link
				rel="icon"
				href={favicon}
			/>
			<title key="title">{title}</title>
			{!!description && (
				<meta
					key="description"
					name="description"
					content={description}
				/>
			)}
			{!!noIndex && (
				<meta
					key="robots"
					name="robots"
					content={noFollow ? 'noindex,nofollow' : 'noindex'}
				/>
			)}
			{keys(meta).map((key) => (
				<meta
					key={key}
					name={key}
					content={meta[key]}
				/>
			))}
			{Children.toArray(links.map((link) => <link {...link} />))}
			<link
				rel="icon"
				href={logo}
			/>
			<meta
				property="og:title"
				content={title}
			/>
			<meta
				property="og:description"
				content={description}
			/>
			<meta
				property="og:url"
				content={canonical}
			/>
			<meta
				property="og:type"
				content="website"
			/>
			<meta
				property="og:image"
				content={logo}
			/>
			<meta
				property="og:site_name"
				content="https://SelfStorage.com"
			/>
			<meta
				name="twitter:card"
				content="summary_large_image"
			/>
			<meta
				name="twitter:site"
				content="@SelfStorageInc"
			/>
			<meta
				name="twitter:title"
				content={title}
			/>
			<meta
				name="twitter:description"
				content={description}
			/>
			<meta
				name="twitter:image"
				content={logo}
			/>
		</Helmet>
	);
}

Head.propTypes = metaPropTypes;
